@if (isLoading) {
	<uc-university-skeleton [header]="false" [banner]="true" />
}
@if (university$ | async; as university) {
	@if (!isLoading) {
		<div class="sticky top-0 z-50 sm:hidden">
			<uc-navigation-tabs
				[postExclusive]="isFeaturedPostgraduateLandingPage"
				[selectedTab]="'clearing'"
				[isPreview]="isPreview"
				[uniSlug]="university.slug"
			/>
		</div>
		<ng-container *ucRemoveDuplicateDomElement="'hideOnMobile'">
			@if (university) {
				<uc-university-header
					[logo]="university.logo"
					[uniName]="university.name"
					[saved]="university.saved"
					[id]="university.id"
					[delta]="1"
					[ugSearchOrderPosition]="null"
					[cleSearchOrderPosition]="university.order"
					product="clearing"
				>
					<uc-university-header-title
						headerTitle
						[name]="university.name"
						[recommendedPercentage]="university.stats.recommended_percentage"
						[paidFeatures]="university.paid_features"
						[subdirectory]="'clearing'"
						[product]="product"
						[slug]="university.slug"
						[uniId]="university.id"
					/>
					<!-- Desktop -->
					<div
						navigation
						class="flex items-center justify-between text-xs font-medium sm:border-t"
					>
						<uc-navigation-tabs
							[postExclusive]="isFeaturedPostgraduateLandingPage"
							[selectedTab]="'clearing'"
							[isPreview]="isPreview"
							[uniSlug]="university.slug"
						/>
					</div>
				</uc-university-header>
			}
		</ng-container>
		<div class="relative">
			@if (isFeaturedClearing) {
				<uc-clearing-available-badge
					[currentClearingYear]="currentClearingYear"
				/>
			}
			<uc-university-slider
				[uniGallery]="uniGallery"
				[product]="product"
				[isFeaturedGallery]="isFeaturedClearing"
				[uniSliderCopy]="uniSliderCopy"
				[id]="university.id"
				[saved]="university.saved"
				[delta]="1"
				[uniName]="university.name"
				[ugSearchOrderPosition]="null"
				[cleSearchOrderPosition]="university.order"
			>
				<uc-university-header-title
					headerTitle
					[name]="university.name"
					[recommendedPercentage]="university.stats.recommended_percentage"
					[paidFeatures]="university.paid_features"
					subdirectory="clearing"
					[product]="product"
					[slug]="university.slug"
					[uniId]="university.id"
				/>
				@if (isFeaturedClearing && (isClearing || isPreview)) {
					<uc-cta-clearing
						[isFeaturedClearingVisitWebsite]="isFeaturedClearingVisitWebsite"
						[isFeaturedRegisterInterest]="isFeaturedRegisterInterest"
						[isFeaturedCalls]="isFeaturedCalls"
						[externalUrl]="university.external_url"
						[uniName]="university.name"
						[uniId]="university.id"
						[phoneNumber]="university.phone_number"
						sourceType="uni"
						[source]="university.name"
						componentName="Profile Header"
						[cleSearchOrderPosition]="university.order"
						[privacyPolicyUrl]="university.privacy_policy_url"
					/>
				} @else {
					<uc-cta-clearing-non-featured [slug]="university.slug" />
				}
			</uc-university-slider>
		</div>
		@if (isFeaturedClearing && (isClearing || isPreview)) {
			<main class="relative sm:mt-0">
				<div class="container sm:border-t">
					<div class="pt-8 border-t sm:divider sm:border-t-0">
						<uc-university-information
							[totalStudents]="university.stats.total_students"
							[studentsInHalls]="university.stats.students_in_hall"
							[fullTime]="university.stats.full_time_students_percentage"
							[avgTariffPoints]="university.stats.average_entry_tariff"
						/>
					</div>
					@if (university.overview) {
						<div class="flex flex-col gap-4 divider">
							<uc-heading
								headingTitle="{{ university.name }} Clearing {{
									currentClearingYear
								}} Overview"
								[description]="university.overview"
							/>
							@if (
								isFeaturedClearingVisitWebsite && university.external_url
							) {
								<uc-clearing-visit-website-btn
									[externalUrl]="university.external_url"
									[source]="university.name"
									[uniId]="university.id"
									sourceType="uni"
									customStyles="w-full sm:max-w-xs"
									componentName="About University"
									[uniName]="university.name"
									[cleSearchOrderPosition]="university.order"
									[privacyPolicyUrl]="university.privacy_policy_url"
								/>
							}
						</div>
					}
				</div>
				<uc-course-search-banner
					[product]="product"
					[uniName]="university.name"
					[uniSlug]="university.slug"
					description="Fancy a new challenge? Find the perfect course for you with our Clearing course search."
				/>
				<div class="container">
					@if (university.usp.text) {
						<div class="flex flex-col gap-4 !border-b-0 divider">
							<uc-heading
								headingTitle="Why Choose {{
									university.name
								}} During Clearing"
								[description]="university.usp.text"
							/>
							@if (
								isFeaturedClearingVisitWebsite && university.external_url
							) {
								<uc-clearing-visit-website-btn
									[externalUrl]="university.external_url"
									[source]="university.name"
									[uniId]="university.id"
									sourceType="uni"
									customStyles="w-full sm:max-w-xs"
									componentName="Why Choose University"
									[uniName]="university.name"
									[cleSearchOrderPosition]="university.order"
									[privacyPolicyUrl]="university.privacy_policy_url"
								/>
							}
						</div>
					}
				</div>
				<!-- Clearing Footer -->
				<uc-clearing-cta-final
					[uniId]="university.id"
					[uniName]="university.name"
					[isFeaturedCalls]="isFeaturedCalls"
					[isFeaturedRegisterInterest]="isFeaturedRegisterInterest"
					[isFeaturedClearingVisitWebsite]="isFeaturedClearingVisitWebsite"
					[phoneNumber]="university.phone_number"
					[externalUrl]="university.external_url"
					[currentClearingYear]="currentClearingYear"
					[source]="university.name"
					[cleSearchOrderPosition]="university.order"
					[privacyPolicyUrl]="university.privacy_policy_url"
				/>
			</main>
		}
		<!-- FAQ for both premium & regular users -->
		<!-- select information from GraphQL query again -->
		<!-- @if (shouldDisplayFaq(university.faqs)) {
			<div class="container">
				<div
					[ngClass]="{
						'border-t': !isFeaturedClearing && !isPreview,
					}"
				>
					<uc-faq-accordion
						[heading]="university.name + ' FAQs'"
						[faq]="university.faqs"
						[ugSearchOrderPosition]="null"
						[cleSearchOrderPosition]="uni.order"
						[ngContentInserted]="isFeaturedCalls"
					>
						@if (isFeaturedCalls && university.phone_number) {
							<uc-clearing-call-faq
								[uniName]="university.name"
								[uniId]="university.id"
								[uniTel]="university.phone_number"
								[cleSearchOrderPosition]="university.order"
							/>
						}
						<uc-clearing-course-availability-faq
							[uniName]="university.name"
							[isFeaturedClearing]="isFeaturedClearing"
						/>

						<ng-template #visitWebsiteBtnFaq>
							<uc-clearing-visit-website-btn
								[externalUrl]="university.external_url"
								customStyles="w-full sm:w-auto"
								componentName="FAQ"
								[uniId]="university.id"
								buttonText="Find Out More"
								sourceType="uni"
								[source]="university.name"
								[cleSearchOrderPosition]="university.order"
								[privacyPolicyUrl]="university.privacy_policy_url"
								[uniName]="university.name"
							/>
						</ng-template>
					</uc-faq-accordion>
				</div>
			</div>
		}-->
		@if (!isFeaturedClearing) {
			<div class="container pb-8 lg:pb-0">
				<uc-recommended-unis-grid
					[product]="product"
					componentName="CLE Recommended Universities"
				/>
			</div>
		}
		<!-- On mobile -> show university buttons at the bottom -->
		@if (university) {
			<uc-client-profile-sticky-lead-bar-mobile [isFeatured]="isFeaturedClearing">
				<uc-clearing-visit-website-btn
					customStyles="w-full"
					[externalUrl]="university.external_url"
					componentName="Sticky Lead Bar"
					[uniId]="university.id"
					[source]="university.name"
					sourceType="uni"
					[uniName]="university.name"
					[cleSearchOrderPosition]="university.order"
					[privacyPolicyUrl]="university.privacy_policy_url"
				/>
			</uc-client-profile-sticky-lead-bar-mobile>
		}
		<!-- On desktop -> show university buttons at the bottom -->
		@if (isFeaturedClearing) {
			<uc-client-profile-sticky-lead-bar-desktop
				[uniId]="university.id"
				[uniName]="university.name"
				[product]="product"
				[paidFeatures]="university.paid_features!"
				[externalUrl]="university.external_url"
				[phoneNumber]="university.phone_number"
				[showClearing]="true"
				[source]="university.name"
				sourceType="uni"
				[ugSearchOrderPosition]="null"
				[cleSearchOrderPosition]="university.order"
			/>
		}
	}
}
